import {Inject, Injectable, DOCUMENT} from '@angular/core';
import {environment} from '../environments/environment';
import {ActivatedRoute, Router} from '@angular/router';
import {Meta, Title} from '@angular/platform-browser';

const NUM_SPACES = environment.NUM_SPACES;

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  DEFAULT_ROBOT = "all"

  // Platform      | Max Chars | Display Recommended | Safe Zone
  // Google Search | ~60 chars | 50-60               | 50
  // Facebook      | ~88 chars | 40-60               | 40
  // Twitter       | ~70 chars | 50-70               | 50
  // LinkedIn      | ~70 chars | 40-60               | 40
  DEFAULT_TITLE = "Croissant | Find Coworking Spaces & Book Conference Rooms"

  // Platform      | Max Display | Recommended | Safe Zone
  // Google Search | ~160 chars  | 150-160     | 150
  // Facebook      | ~300 chars  | 200-300     | 200
  // Twitter       | ~200 chars  | 150-200     | 150
  // LinkedIn      | ~200 chars  | 150-200     | 150
  DEFAULT_DESCRIPTION = `The easiest way to find workspace anywhere. One membership unlocks ${NUM_SPACES}+ coworking spaces across major cities. Book instantly, check in with your phone, and start working immediately.`

  DEFAULT_IMAGE = `${environment.WWW}/images/space.jpg`

  constructor(@Inject(DOCUMENT) private document: Document,
              private route: ActivatedRoute,
              private router: Router,
              private title: Title,
              private meta: Meta) {
  }

  getURL() {
    let isRoot = this.route.snapshot.url.length === 0
    let url = `${environment.WWW}${isRoot ? '' : '/'}${this.router.url}`
    let urlWithoutParameters = url.indexOf("?") !== -1 ? url.split("?")[0] : url
    return urlWithoutParameters;
  }

  setRobots(robots = this.DEFAULT_ROBOT) {
    this.meta.updateTag({name: 'robots', content: robots})
  }

  setTitle(title = this.DEFAULT_TITLE) {
    this.title.setTitle(title);
    this.meta.updateTag({name: 'ogTitle', content: title})
    this.meta.updateTag({name: 'twitter:title', content: title})
  }

  setDescription(description = this.DEFAULT_DESCRIPTION) {
    this.meta.updateTag({name: 'description', content: description})
    this.meta.updateTag({name: 'ogDescription', content: description})
    this.meta.updateTag({name: 'twitter:description', content: description})
  }

  setImage(image = this.DEFAULT_IMAGE) {
    this.meta.updateTag({name: 'ogImage', content: image})
    this.meta.updateTag({name: 'twitter:image', content: image})
  }

  setUrl(url = this.getURL()) {
    this.meta.updateTag({name: 'ogUrl', content: url})
    this.setCanonicalUrl(url)
  }

  setCanonicalUrl(url = this.getURL()) {
    this.document.querySelector("link[rel='canonical']")!.setAttribute('href', url);
  }

}
